<template>
  <div>
    <Head title="Teams" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-600 hover:text-orange-500" href="/users">
        <span class="text-orange-600 font-medium"> Users - </span>
      </Link>
      {{ user.first_name }} {{ user.last_name }} - Teams
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden mb-5">
      <form @submit.prevent="assignTeam">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
          <div class="w-1/3 lg:w-1/3">
            <select-input
              v-model="form.team"
              :error="form.errors.team"
              class="pb-2 pr-6 w-full lg:w-full"
            >
              <option :value="null">
                Select the team
              </option>
              <option
                v-for="tm in teams"
                :key="tm.id"
                :value="tm.id"
              >
                {{ tm.name }}
              </option>
            </select-input>
          </div>
          <div class="w-1/3 lg:w-1/3">
            <loading-button
              :loading="form.processing"
              class="btn-orange px-3 py-2 text-sm"
              type="submit"
            >
              Assign Team
            </loading-button>
          </div>
        </div>
        <!--
        <div
          class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Assign Team
          </loading-button>
        </div>
    -->
      </form>
    </div>
    <hr />
    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Team</th>
          <th class="pb-3 pt-3 px-3" />
        </tr>
        <tr v-for="item in userTeams" :key="item.name" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t pb-3 pt-3 px-3">
            {{ item.name }}
          </td>
          <td class="w-px border-t pb-3 pt-3 px-3">
            <a href="#" @click="deleteTeam(item.id)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="userTeams.length === 0">
          <td class="px-2 py-2 border-t" colspan="9">No data found</td>
        </tr>
      </table>
    </div>
    <!-- <pagination class="mt-6" :links="xinventories.links" /> -->
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import axios from 'axios'
  
export default {
  components: {
    Head,
    Link,
    SelectInput,
    LoadingButton,
  },
  layout: Layout,
  props: {
    filters: Object,
    userTeams: Object,
    teams: Object,
    user: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        team: null,
        user: this.user.id,
      }),
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  methods: {
    assignTeam() {
      this.form.post(`/users/${this.user.id}/assign-teams`)
    /*
      e.preventDefault()
      // this.form.post('/inventories')
      this.locationError = ''
      this.quantityError = ''
      this.itemError = ''
      this.msgSuccess = ''
      this.show = false
      const self = this
      axios.post('/inventories', this.form).then(response => {
        if (response) {
          self.show = true
          self.msgSuccess = response.data.message
          axios.get(`/inventory-location-scans/${this.form.location}/search`).then(response => {
            this.xinventories = response.data
          })
        }
      }).catch(function(error) {
        if (error.response.status === 422) {
          const errMsg = error.response.data.errors
          self.locationError = errMsg.location ? errMsg.location[0] : ''
          self.quantityError = errMsg.quantity ? errMsg.quantity[0] : ''
          self.itemError = errMsg.item_id ? errMsg.item_id[0] : ''
        }
      })
      this.form.item_id = ''
      this.form.quantity = ''
      */
    },
    deleteTeam(item) {
      if (confirm('Are you sure you want to delete this team?')) {
        axios.post(`/delete-team/${item}/user/${this.user.id}`, {team: item, user: this.user.id}).then(response => {
          if(response.data.status === 'success') {
            alert(response.data.message)
            this.$inertia.get(`/users/${this.user.id}/teams`)
          } else {
            alert(response.data.message)
          }
        })
      }
    },
    // deleteTeam(item) {
    //   axios.get(`/inventory-location-scans/${this.form.location}/search`).then(response => {
    //     this.xinventories = response.data
    //   })
    // },
    /*
    updateScans() {
      axios.get(`/inventory-location-scans/${this.form.location}/search`).then(response => {
        this.xinventories = response.data
      })
    }, */
  },
}
</script>
  